// src/modules/router.ts
export type RouteHandler = (params: Record<string, string>) => void;

interface RouterOptions {
  fallback?: (path: string) => void;
}

interface CompiledRoute {
  pattern: string;
  regex: RegExp;
  keys: string[];
  handler: RouteHandler;
}

export class Router {
  private routes: CompiledRoute[] = [];
  private fallback: (path: string) => void;
  private _onHashChange: () => void;

  constructor(options: RouterOptions = {}) {
    this.fallback = options.fallback || (() => {});
    this._onHashChange = this.handleHashChange.bind(this);
  }

  add(pattern: string, handler: RouteHandler): this {
    const keys: string[] = [];
    const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, m => {
      keys.push(m.slice(1));
      return '([^/]+)';
    }) + '$');
    this.routes.push({ pattern, regex, keys, handler });
    return this;
  }

  start(): void {
    window.addEventListener('hashchange', this._onHashChange);
    this._onHashChange();
  }

  stop(): void {
    window.removeEventListener('hashchange', this._onHashChange);
  }

  navigate(path: string): void {
    window.location.hash = '#' + path;
  }

  private handleHashChange(): void {
    const path = (window.location.hash || '#/').slice(1) || '/';
    for (const r of this.routes) {
      const m = path.match(r.regex);
      if (m) {
        const params: Record<string, string> = {};
        r.keys.forEach((k, i) => {
          const v = m[i + 1];
          if (v !== undefined) params[k] = v;
        });
        r.handler(params);
        return;
      }
    }
    this.fallback(path);
  }
}
